<template>
  <div class="roleBox">
    <Form ref="searchForm" :label-width="180" :model="formCustom" inline>
      <Form-item label="产品名称：">
        <Input v-model="formCustom.employeeRealName" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="产品分类：">
        <Input v-model="formCustom.employeeIdNumber" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="申请人姓名：">
        <Input v-model="formCustom.employeeRealName" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="申请人手机号：">
        <Input v-model="formCustom.employeeMobilephone" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="审核状态：" prop="roleName">
        <Select v-model="formCustom.employeeIsOnJob" clearable filterable style="width: 200px">
          <Option value="1">待审核</Option>
          <Option value="0">审核通过</Option>
          <Option value="0">审核拒绝</Option>
        </Select>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')">重置</Button>
      </Form-item>
    </Form>
    <div style="margin-bottom: 20px">
      <Button class="btn" type="primary" @click="add">新增产品</Button>
    </div>
    <div>
      <Table :columns="roleColumns" :data="roleTableData" :loading="loading" aria-describedby=""
             aria-hidden="true" border @on-selection-change="selectionChange">
        <template slot="employeeJobForm" slot-scope="{ row }">
          <span>
            {{
              row.employeeJobForm == 1 ? '自有' : row.employeeJobForm == 2 ? '外包' :
                row.employeeJobForm == 3 ? '派遣' : row.employeeJobForm == 4 ? '项目' : ''
            }}
          </span>
        </template>
        <template slot="employeeIsOnJob" slot-scope="{ row }">
          <span>
            {{ row.employeeIsOnJob ? '在职' : '离职' }}
          </span>
        </template>
        <template slot="employeeJobType" slot-scope="{ row }">
          <span>
            {{ row.employeeJobType == 1 ? '全职' : row.employeeJobType == 2 ? '兼职' : '实习' }}
          </span>
        </template>

        <template slot="action" slot-scope="{ row }">
          <Button size="small" type="text" @click="editShow(row)">编辑</Button>
          <Button size="small" type="text" @click="quitShow(row)">上架</Button>
          <Button size="small" type="text" @click="deleteroster(row)">下架</Button>
        </template>
      </Table>
      <Page ref="pages" :current="page" :total="total" class="page_position" show-elevator show-sizer show-total
            @on-change="setCurrent" @on-page-size-change="setPage"></Page>
    </div>

  </div>
</template>

<script>
import {companyEmployeePage} from '@/api/organization'

export default {
  name: 'productManagement',
  data() {
    return {
      total: 0,
      page: 1,
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      lockMsg: '', // 锁定/解锁
      lockStatus: '', //锁定/解锁状态
      companyIds: '',
      formCustom: {},
      roleColumns: [
        {type: 'selection', width: 60, align: 'center'},
        {title: '产品名称', key: 'employeeRealName', align: 'center'},
        {title: '产品分类', key: 'employeeIdNumber', align: 'center'},
        {title: '产品描述', key: 'employeeMobilephone', align: 'center'},
        {title: '服务供应商公司', key: 'deptName', align: 'center'},
        {title: '申请人姓名', key: 'employeeResponsibilitie', align: 'center'},
        {title: '申请人手机号', key: 'employeeWorktypeName', align: 'center'},
        {title: '审核状态', key: 'employeeIsOnJob', slot: 'employeeIsOnJob', align: 'center'},
        {title: '审核时间', key: 'employeeIsOnJob', align: 'center'},
        {title: '操作', slot: 'action', align: 'center', fixed: 'right'}
      ],
      roleTableData: [], // 表格数据
      areaData: [],
      props: {value: 'id'},
      countyCode: '',
      row: {},
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // 初始化
    init() {
      this.loading = true
      companyEmployeePage({
        current: 1,
        size: 10,
      }).then((res) => {

        this.changeData(res)
      })
    },
    add() {
      this.$router.push({name: 'addProduct'})
    },
    selectionChange(s) {
      if (s && s.length > 0) {
        let a = []
        s.forEach(e => {
          a.push(e.companyId)
        })
        this.companyIds = a.join(",")
      }
    },
    handleReset(name) {
      this.$refs[name].resetFields()
      // 重置查询条件会再次查询
      this.handleSearch()
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total
      this.size = res.data.data.size
      this.roleTableData = res.data.data.records
      res.data.data.records.forEach((element, index) => {
        if (element.status === -1) {
          this.roleTableData[index].status = '锁定'
        } else if (element.status === 1) {
          this.roleTableData[index].status = '有效'
        }
      })
      this.loading = false
    },
    // 查询
    handleSearch() {
      const data = {
        ...this.formCustom
      };
      companyEmployeePage({
        current: 1,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 改变页码
    setCurrent(val) {
      const data = {
        ...this.formCustom
      };
      if (this.formCustom.countyCode.length > 0) {
        data.countyCode = this.countyCode
      }
      this.loading = true
      this.page = val
      companyEmployeePage({
        current: val,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 改变每页条数
    setPage(val) {
      const data = {
        ...this.formCustom
      };
      if (this.formCustom.countyCode.length > 0) {
        data.countyCode = this.countyCode
      }
      this.loading = true
      this.pageSize = val
      companyEmployeePage({
        current: 1,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    }
  }
}
</script>
<style lang="less">
.next {
  border-radius: 4px;
  background-color: rgba(0, 123, 211, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  height: 50px;
  border-color: #3A62D7;
  width: 90px;
}

.btn {
  margin-left: 30px;
  margin-top: 10px;
}
</style>
